module.exports = __webpack_public_path__ + "static/media/background1.f85b103a.webp";